import "../styles/Main.scss";
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

//비주얼
import visualBgImg01 from '../assets/images/visual/pc_hero_Image_1.png';
import visualBgImg02 from '../assets/images/visual/pc_hero_Image_2.png';
import visualBgImg03 from '../assets/images/visual/pc_hero_Image_3.png';
import visualBgMobileImg01 from '../assets/images/visual/mobile_hero_Image_1.png';
import visualBgMobileImg02 from '../assets/images/visual/mobile_hero_Image_2.png';
import visualBgMobileImg03 from '../assets/images/visual/mobile_hero_Image_3.png';

import scrollIcon from '../assets/images/visual/scroll-icon.svg';
import logo from '../assets/images/visual/logo.svg';
import logoTablet from '../assets/images/visual/logo-tablet.svg';
import logoMobile from '../assets/images/visual/logo-mobile.svg';
import footerLogo from '../assets/images/footer/footer-logo.svg';

//what-we-do
import whatWeDoIcon01 from '../assets/images/what-we-do/what-we-do-icon01.svg';
import whatWeDoIcon02 from '../assets/images/what-we-do/what-we-do-icon02.svg';
import whatWeDoIcon03 from '../assets/images/what-we-do/what-we-do-icon03.svg';

//our-technology
import OurTechnologyIcon01 from '../assets/images/our-technology/3dcube.svg';
import OurTechnologyIcon02 from '../assets/images/our-technology/cpu-charge.svg';
import OurTechnologyIcon03 from '../assets/images/our-technology/share.svg';
import OurTechnologyIcon04 from '../assets/images/our-technology/favorite-chart.svg';




function Main({}) {


  return (
    <>
      <div className="main">
        <MainVisual/>
        <WhatWeDo/>
        <OurTechnology/>
        <Footer/>
      </div>
    </>
  );
}

export default Main;





const useImageTransition = (images, interval = 3000) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(1);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const imageRefs = useRef(images.map(() => new Image()));

    // 이미지 프리로드
    useEffect(() => {
        images.forEach((src, index) => {
            const img = imageRefs.current[index];
            img.src = src;
        });
    }, [images]);

    useEffect(() => {
        const timer = setInterval(() => {
            setNextIndex((currentIndex + 1) % images.length);
            setIsTransitioning(true);
            
            setTimeout(() => {
                setCurrentIndex((currentIndex + 1) % images.length);
                setIsTransitioning(false);
            }, 1000);
        }, interval);

        return () => clearInterval(timer);
    }, [currentIndex, images.length, interval]);

    return { currentIndex, nextIndex, isTransitioning };
};

const MainVisual = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const pcImages = [visualBgImg01, visualBgImg02, visualBgImg03];
    const mobileImages = [visualBgMobileImg01, visualBgMobileImg02, visualBgMobileImg03];
    const images = isMobile ? mobileImages : pcImages;
    const { currentIndex, nextIndex, isTransitioning } = useImageTransition(images);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="main-visual">
            <div className="main-visual__bg">
                {images.map((src, index) => (
                    <img
                        key={src}
                        src={src}
                        alt="visual-bg"
                        style={{
                            opacity: index === currentIndex ? 1 :
                                    index === nextIndex && isTransitioning ? 1 : 0
                        }}
                    />
                ))}
            </div>
            <div className="inner">
                <div className="main-visual__content">
                    <h2 className="main-visual__title">
                        Connect with Tech,<br />
                        Grow with Trust.
                    </h2>
                    <p className="main-visual__text">
                        파트너와 함께 새로운 가치를 만들어갑니다.
                    </p>
                    <a 
                      className="main-visual__button" 
                      href="mailto:kys1227@tconnect.co.kr"
                    >Contact us</a>
                </div>
                <p className="main-visual__scroll">
                    <img src={scrollIcon} alt="scroll" />
                </p>
                <p className="main-visual__logo">
                    <img src={logo} className="main-visual__logo__pc" alt="logo" />
                    <img src={logoTablet} className="main-visual__logo__tablet" alt="logo" />
                    <img src={logoMobile} className="main-visual__logo__mobile" alt="logo" />
                </p>
            </div>
        </div>
    );
};


const WhatWeDo = () => {
  const [isVisible, setIsVisible] = useState(false);
  const lastItemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px'
      }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div id="what-we-do" className="what-we-do">
        <div className="inner">
          <h3>What We Do</h3>
          <h4>
            국내외 선도 기술 파트너들의 역량을 결집하여,
            <span>업계 최고 수준의 인증을 바탕으로 완성도 높은 인프라와 솔루션을 제공합니다.</span>
          </h4>
          <div className={`what-we-do__content ${isVisible ? 'active' : ''}`}>
            <div className="what-we-do__content__item">
              <img src={whatWeDoIcon01} alt="what-we-do-icon01" />
              Expertise & Experience
            </div>
            <div className="what-we-do__content__item">
              <img src={whatWeDoIcon02} alt="what-we-do-icon02" />
              Industry-Leading Partnerships
            </div>
            <div className="what-we-do__content__item" ref={lastItemRef}>
              <img src={whatWeDoIcon03} alt="what-we-do-icon03" />
              End-to-End Support
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const OurTechnology = () => {
  const [isVisible, setIsVisible] = useState(false);
  const lastItemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // 한 번만 실행되도록 observer 해제
        }
      },
      {
        threshold: 0.1, // 요소가 10% 보일 때 감지
        rootMargin: '0px' // 뷰포트 하단에 정확히 닿았을 때 감지
      }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="our-technology">
        <div className="inner">
          <div className="our-technology__left">
            <h3>
              Our Technology
            </h3>
            <h4>
              기술 조달 과정을 단순하고 효율적으로 만듭니다.
              <span>필요한 기술을 그 어느 때보다 쉽게 구매할 수 있습니다.</span>
            </h4>
            <a 
              className="our-technology__button" 
              href="mailto:kys1227@tconnect.co.kr"
            >지금 문의 하기</a>
          </div>
          <div className={`our-technology__content ${isVisible ? 'active' : ''}`}>
            <div className="our-technology__content__item">
              <img src={OurTechnologyIcon01} alt="our-technology-icon01" />
              시스템 서비스 사업
            </div>
            <div className="our-technology__content__item">
              <img src={OurTechnologyIcon02} alt="our-technology-icon02" />
              IT 아웃소싱
            </div>
            <div className="our-technology__content__item">
              <img src={OurTechnologyIcon03} alt="our-technology-icon03" />
              장비 임대 및 이전 서비스
            </div>
            <div className="our-technology__content__item" ref={lastItemRef}>
              <img src={OurTechnologyIcon04} alt="our-technology-icon04" />
              컨설팅
            </div>
          </div>
          <a 
            className="our-technology__button mobile" 
            href="mailto:kys1227@tconnect.co.kr"
          >지금 문의 하기</a>
        </div>
      </div>
    </>
  );
};




const Footer = () => {
  const scrollToWhatWeDo = (e) => {
    e.preventDefault();
    const whatWeDoSection = document.getElementById('what-we-do');
    if (whatWeDoSection) {
      whatWeDoSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
      <>
        <div className="footer">
          <div className="inner">
            <div className="footer__left">
              <p className="footer__left__title">테크커넥트(주)</p>
              <div className="footer__left__text">
                <dl className="footer__left__text__item">
                  <dt>대표 <p>김영수</p></dt>
                  <dd>
                    사업자등록번호
                    <p>230-87-02707</p>
                  </dd>
                </dl>
                <dl className="footer__left__text__item">
                  <dt>주소</dt>
                  <dd>
                    <p>서울 구로구 디지털로26길 5, 1305호(에이스 하이엔드타워 1차)</p>
                  </dd>
                </dl>
                <dl className="footer__left__text__item">
                  <dt>문의사항<p>kys1227@tconnect.co.kr</p></dt>
                  <dd>
                    팩스번호
                    <p>02-6455-3816</p>
                  </dd>
                </dl>
              </div>
              {/* <ul className="footer__left__link">
                <li>
                  <a href="#what-we-do" onClick={scrollToWhatWeDo}>
                    회사소개
                  </a>
                </li>
                <li>
                  <Link to="/">
                    이용약관
                  </Link>
                </li>
                <li>
                  <Link to="/">
                    개인정보처리방침
                  </Link>
                </li>
              </ul> */}
            </div>
            <div className="footer__right">
              <a 
                href="/" 
                className="footer__right__logo"
                onClick={(e) => {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                <img src={footerLogo} alt="logo" />
              </a>
            </div>
          </div>
        </div>
      </>
  );
};

